import i18n from "i18next";
import { initReactI18next } from "react-i18next";

//CATALAN
import caCommon from './locales/ca/common.json';
import caAuth from './locales/ca/auth.json';
import caMenu from './locales/ca/menu.json';
import caAdmin from './locales/ca/admin.json';

import caDashboard from './locales/ca/dashboard.json';
import caClaim from './locales/ca/claim.json';
import caAlert from './locales/ca/alert.json';
import caClient from './locales/ca/client.json';
import caClientParams from './locales/ca/clientParams.json';
import caUser from './locales/ca/user.json';
import caSurvey from './locales/ca/survey.json';
import caTemplate from './locales/ca/template.json';
import caCampaign from './locales/ca/campaign.json';
import caSurveyAdmin from './locales/ca/surveyAdmin.json';
import caParticipant from './locales/ca/participant.json';
import caEvent from './locales/ca/event.json';
import caGenericDic from './locales/ca/genericDic.json';
import caQuestion from './locales/ca/question.json';
import caAuditLog from './locales/ca/auditLog.json';
import caRole from './locales/ca/role.json';
import caPermission from './locales/ca/permission.json';
import caSentiment from './locales/ca/sentiment.json';
import caImprovementPlan from './locales/ca/improvementPlan.json';
import caTopic from './locales/ca/topic.json';
import caSecurityIPs from './locales/ca/securityIPs.json';
import caExtraField from './locales/ca/extraField.json';
import caNotification from './locales/ca/notification.json';
import caClaimRequestType from './locales/ca/claimRequestType.json';
import caOrganizationalStructure from './locales/ca/organizationalStructure.json';
import caUserCommunicationType from './locales/ca/userCommunicationType.json';
import caProfessional from './locales/ca/professional.json';
import caReportDefinition from './locales/ca/reportDefinition.json';


//ESPAÑOL
import esCommon from './locales/es/common.json';
import esAuth from './locales/es/auth.json';
import esMenu from './locales/es/menu.json';
import esAdmin from './locales/es/admin.json';

import esDashboard from './locales/es/dashboard.json';
import esClaim from './locales/es/claim.json';
import esAlert from './locales/es/alert.json';
import esClient from './locales/es/client.json';
import esClientParams from './locales/es/clientParams.json';
import esUser from './locales/es/user.json';
import esSurvey from './locales/es/survey.json';
import esTemplate from './locales/es/template.json';
import esCampaign from './locales/es/campaign.json';
import esSurveyAdmin from './locales/es/surveyAdmin.json';
import esParticipant from './locales/es/participant.json';
import esEvent from './locales/es/event.json';
import esGenericDic from './locales/es/genericDic.json';
import esQuestion from './locales/es/question.json';
import esAuditLog from './locales/es/auditLog.json';
import esRole from './locales/es/role.json';
import esPermission from './locales/es/permission.json';
import esSentiment from './locales/es/sentiment.json';
import esImprovementPlan from './locales/es/improvementPlan.json';
import esTopic from './locales/es/topic.json';
import esSecurityIPs from './locales/es/securityIPs.json';
import esExtraField from './locales/es/extraField.json';
import esNotification from './locales/es/notification.json';
import esClaimRequestType from './locales/es/claimRequestType.json';
import esOrganizationalStructure from './locales/es/organizationalStructure.json';
import esUserCommunicationType from './locales/es/userCommunicationType.json';
import esProfessional from './locales/es/professional.json';
import esReportDefinition from './locales/es/reportDefinition.json';

//INGLES
import enCommon from './locales/en/common.json';
import enAuth from './locales/en/auth.json';
import enMenu from './locales/en/menu.json';
import enAdmin from './locales/en/admin.json';

import enDashboard from './locales/en/dashboard.json';
import enClaim from './locales/en/claim.json';
import enAlert from './locales/en/alert.json';
import enClient from './locales/en/client.json';
import enClientParams from './locales/en/clientParams.json';
import enUser from './locales/en/user.json';
import enSurvey from './locales/en/survey.json';
import enTemplate from './locales/en/template.json';
import enCampaign from './locales/en/campaign.json';
import enSurveyAdmin from './locales/en/surveyAdmin.json';
import enParticipant from './locales/en/participant.json';
import enEvent from './locales/en/event.json';
import enGenericDic from './locales/en/genericDic.json';
import enQuestion from './locales/en/question.json';
import enAuditLog from './locales/en/auditLog.json';
import enRole from './locales/en/role.json';
import enPermission from './locales/en/permission.json';
import enSentiment from './locales/en/sentiment.json';
import enImprovementPlan from './locales/en/improvementPlan.json';
import enTopic from './locales/en/topic.json';
import enSecurityIPs from './locales/en/securityIPs.json';
import enExtraField from './locales/en/extraField.json';
import enNotification from './locales/en/notification.json';
import enClaimRequestType from './locales/en/claimRequestType.json';
import enOrganizationalStructure from './locales/en/organizationalStructure.json';
import enUserCommunicationType from './locales/en/userCommunicationType.json';
import enProfessional from './locales/en/professional.json';
import enReportDefinition from './locales/en/reportDefinition.json';

import LanguageDetector from "i18next-browser-languagedetector";

const resources = {
    ca: {
        common: caCommon,
        auth: caAuth,
        menu: caMenu,
        admin: caAdmin,
        dashboard: caDashboard,

        clientParams: caClientParams,
        client: caClient,  //transalated
        claim: caClaim, //transalated
        alert: caAlert, //transalated
        user: caUser,
        survey: caSurvey, //transalated
        template: caTemplate,  //transalated
        campaign: caCampaign,
        surveyAdmin: caSurveyAdmin,
        participant: caParticipant,
        event: caEvent,
        genericDic: caGenericDic,
        question: caQuestion,
        auditLog: caAuditLog,
        role: caRole,
        permission: caPermission,
        sentiment: caSentiment,
        improvementPlan: caImprovementPlan,
        topic: caTopic,
        securityIPs: caSecurityIPs,
        extraField: caExtraField,
        notification: caNotification,
        claimRequestType: caClaimRequestType,
        organizationalStructure: caOrganizationalStructure,
        userCommunicationType: caUserCommunicationType,
        professional: caProfessional,
        reportDefinition: caReportDefinition
    },
    es: {
        common: esCommon,
        auth: esAuth,
        menu: esMenu,
        admin: esAdmin,
        dashboard: esDashboard,

        clientParams: esClientParams,
        client: esClient,
        claim: esClaim,
        alert: esAlert,
        user: esUser,
        survey: esSurvey,
        template: esTemplate,
        campaign: esCampaign,
        surveyAdmin: esSurveyAdmin,
        participant: esParticipant,
        event: esEvent,
        genericDic: esGenericDic,
        question: esQuestion,
        auditLog: esAuditLog,
        role: esRole,
        permission: esPermission,
        sentiment: esSentiment,
        improvementPlan: esImprovementPlan,
        topic: esTopic,
        securityIPs: esSecurityIPs,
        extraField: esExtraField,
        notification: esNotification,
        claimRequestType: esClaimRequestType,
        organizationalStructure: esOrganizationalStructure,
        userCommunicationType: esUserCommunicationType,
        professional: esProfessional,
        reportDefinition: esReportDefinition
    },
    en: {
        common: enCommon,
        auth: enAuth,
        menu: enMenu,
        admin: enAdmin,
        dashboard: enDashboard,

        clientParams: enClientParams,
        client: enClient,
        claim: enClaim,
        alert: enAlert,
        user: enUser,
        survey: enSurvey,
        template: enTemplate,
        campaign: enCampaign,
        surveyAdmin: enSurveyAdmin,
        participant: enParticipant,
        event: enEvent,
        genericDic: enGenericDic,
        question: enQuestion,
        auditLog: enAuditLog,
        role: enRole,
        permission: enPermission,

        sentiment: enSentiment,
        improvementPlan: enImprovementPlan,
        topic: enTopic,
        securityIPs: enSecurityIPs,
        extraField: enExtraField,
        notification: enNotification,
        claimRequestType: enClaimRequestType,
        organizationalStructure: enOrganizationalStructure,
        userCommunicationType: enUserCommunicationType,
        professional: enProfessional,
        reportDefinition: enReportDefinition
    },
};

i18n
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
        resources,
        fallbackLng: "es",
        supportedLngs: ["ca", "en", "es"],
        ns: ['common', 'client', 'auth', 'dashboard', 'claim', 'alert', 'user', 'survey', 'template', 'campaing', 'surveyAdmin', 'event', 'genericDic', 'sentiment', 'role', 'permission', 'improvementPlan', 'topic', 'securityIPs', 'extraField', 'notification', 'claimRequestType', 'organizationalStructure', 'userCommunicationType', 'professional', 'reportDefinition'],
        interpolation: {
            escapeValue: false,
        },
        debug: false,
        detection: {
            order: ["localStorage", "cookie", "navigator"],
            caches: ["localStorage", "cookie"]
        },
    });

export default i18n;
